<template>
    <div class="container">
      <!-- <public-title :showBack="isAdmin || isGroup" v-if="queryCon.none!=1">门店资料</public-title> -->
      <public-title v-if="area">门店相册</public-title>
      <div :class="area">
        <div class="radio-group">
            <el-radio-group v-model="radio1" size="small" @input="changeRadio">
            <el-radio-button label="1">门店相册</el-radio-button>
            <el-radio-button label="2">房型相册</el-radio-button>
            <el-radio-button label="3">会议室相册</el-radio-button>
            </el-radio-group>
        </div>
        <div>
            <store-photos  v-if="radio1==1" @saveInfo="info => this.saveAlbum(info,3)" />
            <RoomType v-if="radio1>1" :list="ListArr.meetArr"  @uploadPic="uploadPic"></RoomType>
            <p v-if="radio1>1&& ListArr.total<=0">当前没有数据</p>
            <el-pagination background layout="prev, pager, next" class="mt-4" v-if=" ListArr.total>0"
                :total="ListArr.total" :current-page="Number(queryCon.page)"
                @current-change="v => {this.queryCon.page=v;this.getLists()}"/>
        </div>
      </div>
        <!--修改图片-->
        <el-dialog :title="'修改房型图片'" :visible.sync="modifyTheImage" width="600px" center id="loadConfirm" top="22vh">
            <div class="">当前房型：{{formData.title}}<span v-if="formData.assist">（{{formData.assist}}）</span></div>
            <upload-image @fileChange="(imgs)=>formData.pic = imgs" :existImgs="formData.pic"   :modifyTheImage="true" :maxLength="10"/>
            <div class="theImage-bottom">
                <el-button  @click="modifyTheImage=false" >取消退出</el-button>
                <el-button  @click="submitForm"  type="primary">保存更新</el-button>
            </div>    
        </el-dialog>  
    </div>
</template>

<script>
    import { mapGetters,mapState, mapActions,mapMutations } from 'vuex';
    import { debounce } from "lodash";
    import StorePhotos from './Comps/StorePhotos';
    import RoomType from './Comps/RoomType.vue';
    import { UploadImages } from '@/assets/utils/uploadFiles';
    export default {
    name: '',
    components: {StorePhotos,RoomType},
    props: {
        area: {
            type: String,
            default: 'load-area'
        }
    },
    data() {
        return {
            radio1: 1,          //默认展示门店相册
            queryCon:{
                page: 1,
            },
            modifyTheImage: false,
            formData:{
                feature:'',
            }
        };
    },
    computed: {
        ...mapGetters(['isAdmin']),
        ...mapState(['StoreRoomArr', 'StoreMeetArr']),
        ListArr () {
            switch (this.radio1) {
            case '2': return this.StoreRoomArr
            case '3': return this.StoreMeetArr
            default: return {}
            }
        },
    },
    watch: {},
    created() {
        
    },
    mounted() {
        this.changeRadio('1');
    },
    methods: {
        ...mapActions(['getStoreInfo','HotelsRoomList','HotelsMeetLists','saveRoom','HotelsEditAlbum']),
        /** 切换相册类型 */
        changeRadio: debounce(function(val){
            let data = {};
            this.radio1 = val;
            console.log(val);
            switch (val) {
                case '1': 
                    if (this.isAdmin) {
                        data.is_get_contract_arr = '1';
                        data.is_get_admin_user_arr = '1';
                    }
                    this.getStoreInfo(data);
                break;
                case '2': 
                    
                case '3':
                    this.getLists();
                default:break;
            }
        },500),
        /** 获取列表 */
        getLists() {
            if (this.radio1 === '2') this.HotelsRoomList(this.queryCon);
            if (this.radio1 === '3') this.HotelsMeetLists(this.queryCon);
        },
        /** 打开修改图片弹窗 */
        uploadPic (e) {
            this.formData={...this.formData,...e};
            this.formData.room_id=e.id;
            delete this.formData.id;
            this.modifyTheImage = true;
        },
        /**提交保存图片**/
        submitForm(){
            let {formData}=this;
            if (this.formData.pic.length <= 0) {
            this._alert(`请至少上传一张${this.listType}图片`,null,'error');
            return
            }
            this._confirm('确认提交么？',async () => {
                //上传图片
                this.modifyTheImage = false;
                formData.pic = await UploadImages(formData.pic);
                this.saveRoom({
                    data: formData,
                    successFun: () => {
                        this.getLists();
                    }
                })
            })
        },
        //保存相册
        saveAlbum(info,step){
            this.HotelsEditAlbum({
            type:this.store ?  '' : 'groupAddStore',
            newInfo: info,
            successFun: (id) => {
                let store = this.store || id;
                if(info.tabPosition<3){
                step=1
                }
                this.getStoreInfo();
            }
            })
        },
    }
};
</script>

<style lang="scss" scoped>
    .radio-group{
        text-align: left;
        display: flex;
    }
    .theImage-bottom{
        margin-top: 20px;
        border-top: 1px #eee solid;
        padding-top: 20px;
        text-align: right;
    }
</style>
